export default __webpack_public_path__ + "static/media/careersocius_portal.c772acc6.png";